import React from 'react'
import { connect } from 'dva'
import Color from 'color'
import PropTypes from 'prop-types'
import { isEqual } from '../../../../../lib/utils'
import { ICON_DISPLAY_MAP, MAX_RECENT_STYLES } from '../../../../../lib/constants'
import actions from '../actions'
import Panel from '../../../Panel'
import StyleCircle from './StyleCircle'
import styles from '../FeatureEditor.module.scss'

function FeatureRecentStyles(props) {
	const handleRecentIconStyleSelected = (style) => {
		if (style.icon === 'see-all') {
			props.openIconEdit()
			props.updateSelectedIcon(null)
		} else {
			style.color = new Color(style.color).rgb().color
			style.color.push(1)
			props.updateWaypointStyle(props.selectedFeature, style.color, style.icon)
		}
	}
	const setStyle = (color, icon) => {
		return {
			color: new Color(color).hex(),
			icon: icon,
		}
	}

	let panelActions = []
	if (props.stylesList.length > 2) {
		panelActions = [
			{
				name: 'Clear',
				disabled: !props.stylesList.length,
				onClick: props.clearRecentStyles,
			},
		]
	}

	return (
		<>
			<Panel title='Select Type' actions={panelActions} divider={true}>
				<div className={styles.stylesList}>
					{props.stylesList.map((sl, i) => {
						const { color, icon } = setStyle(sl.color, sl.icon)
						return <StyleCircle active={i === 0} icon={icon} color={color} key={`${icon}-${i}`} onClick={handleRecentIconStyleSelected} styleText={props.styleText} />
					})}
				</div>
			</Panel>
		</>
	)
}

FeatureRecentStyles.propTypes = {
	selectedFeature: PropTypes.object,
	styleText: PropTypes.object,
	stylesList: PropTypes.array,
	// actions
	clearRecentStyles: PropTypes.func,
	openIconEdit: PropTypes.func,
	updateSelectedIcon: PropTypes.func,
	updateWaypointStyle: PropTypes.func,
}

export default connect((model) => {
	const { preferences: { recents = {} }, selectedFeature } = model.features
	const { properties: sfProperties } = selectedFeature
	const currentStyle = { color: sfProperties.color, icon: sfProperties.icon }
	const defaultIcon = 'gohunt-logo'
	const recentPreferencesStyles = recents.styles?.points || []
	const recentStylesList = []
	let recentPreferenceStyle = null
	let styleText = null

	if (!ICON_DISPLAY_MAP[currentStyle.icon]) {
		currentStyle.icon = defaultIcon
	}
	for (let ri = 0; ri < recentPreferencesStyles.length; ri++) {
		recentPreferenceStyle = recentPreferencesStyles[ri]
		if (!ICON_DISPLAY_MAP[recentPreferenceStyle.icon]) {
			recentPreferenceStyle.icon = defaultIcon
		}
		const isDuplicateStyle = isEqual(recentPreferenceStyle, currentStyle)
		if (!isDuplicateStyle) {
			recentStylesList.push(recentPreferenceStyle)
		}
		if (recentStylesList.length === MAX_RECENT_STYLES) break
	}
	const seeAllStyle = { color: [38, 38, 39, 1], icon: 'see-all' }
	const stylesList = [currentStyle, ...recentStylesList, seeAllStyle]
	const styleIndex = stylesList.findIndex(sl => sl.icon.length > 10)
	if (styleIndex > -1) styleText = { height: 30, width: 48 }

	return {
		styleText,
		stylesList,
		selectedFeature,
	}
}, actions)(FeatureRecentStyles)
